import { useState } from "react";
import { BiSolidChevronDown, BiSolidChevronRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import { GetServerParsedName } from "../../../../Services/Servers/ServerHelper";
import { IoIosRadioButtonOff, IoIosRadioButtonOn } from "react-icons/io";
import "./ServerDropdown.css";
import ServerTypes from "../../../../Services/Data/ServerTypes";

const ServerDropdown = ({server}) => {
    const [hidden, setHidden] = useState(true);
    
    const serverName = GetServerParsedName(server.name);

    return (
      <>
        <div className="serverDropdownContainer">
            <div className="serverDropdownBtn center-x" onClick={() => setHidden(!hidden)}>
                <div className="dropdownArrow">
                    { hidden &&
                        <BiSolidChevronRight/> 
                    }
                    { !hidden &&
                        <BiSolidChevronDown/> 
                    }  
                </div>      
                <div>
                    <span dangerouslySetInnerHTML={{__html: serverName}}></span>                         
                </div>                  
                 
                    
            </div>
        </div>

        <div className="serverStatusContainer">                    
            { server.isActive &&
                <div className="serverStatus">
                    { server.playerCount == 0 &&
                        <>
                            <IoIosRadioButtonOn className="text-orange-500"/> 
                            <span className="text-orange-500">Empty</span> 
                        </>   
                    } 
                    { server.playerCount != 0 &&
                        <>
                            <IoIosRadioButtonOn className="text-glgreen"/> 
                            <span className="text-glgreen">Online</span> 
                        </>   
                    }                     
                    <span className="text-glwhite-500">[</span>
                    {server.playerCount}/{server.maxPlayerCount}
                    <span className="text-glwhite-500">]</span>     
                </div>  
            }
            { !server.isActive &&
                <div className="serverStatus text-glred">
                    <IoIosRadioButtonOn/> Offline
                </div> 
            }
        </div> 

        { !hidden &&

            <div className="serverSubpages">
                {ServerTypes[server.serverType].DropDownButtons(server)}
            </div>
        }

      </>  
    );
}

export default ServerDropdown;